import { Component, Inject, OnInit, Optional } from '@angular/core';
import { DialogsAlertComponent } from '../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map, catchError } from 'rxjs/operators';
import { DialogsSendMailsService } from './dialogs-send-mails.service';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { Mail } from 'src/app/core/entities/mail.model';
import { PETICIONES } from 'src/app/core/utils/constants';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-dialogs-send-mails',
  templateUrl: './dialogs-send-mails.component.html',
  styleUrls: ['./dialogs-send-mails.component.css']
})
export class DialogsSendMailsComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $mostrar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  dato : any;
  allTercer : any;
  mensajerror: boolean = false;
  mensajebien: boolean = false;
  mensajemal: boolean = false;
  textoerror: string = "";
  personmail: string = "";

  fileTemp: any;

  title = 'File-Upload-Save';
  selectedFiles: FileList | null = null;;
  currentFileUpload: File | null = null;;
  progress: { percentage: number } = { percentage: 0 };
  selectedFile = null;
  changeImage = false;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogsSendMailsService: DialogsSendMailsService,
              @Optional() private dialogRef: MatDialogRef<DialogsSendMailsComponent>,
              public router: Router,
              private translateService: TranslateService,
              private dialog: MatDialog,
              private repositoryService: RepositoryService) { this.dialogsSendMailsService.build(); }

  ngOnInit() {
    this.mensajerror = false;
    this.mensajebien = false;
    this.mensajemal = false;
    this.loading = false;
  }

  /**
  * @description
  * Cierra el dialog
  */
  public aceptar(mail: Mail)  {

    var ismail = this.isValidMailFormat(mail.emisor);

    /*if(this.fileTemp != undefined){
      mail.archivo.append('myFile', this.fileTemp.fileRaw, this.fileTemp.fileName);
      console.log(mail);
    }*/

    if(ismail){

      this.personmail = _.cloneDeep(mail.emisor);
      this.loading = true;
      this.repositoryService.doPost(PETICIONES.webservice.doPostMail, mail).subscribe(result => {
        console.log(result);
        this.mensajerror = true;
        this.dialogsSendMailsService.mail = new Mail();
        if(result){
          this.mensajebien = true;
          this.mensajemal = false;
          let texto = this.translateService.instant('WARNINGS.error_correo_bien');
          this.textoerror = texto + ": " + mail.emisor.bold();
        }else{
          this.mensajebien = false;
          this.mensajemal = true;
          let texto = this.translateService.instant('WARNINGS.error_correo_mal');
          this.textoerror = texto + ": " + mail.emisor.bold();
        }
        this.loading = false;
        return true;
      }),catchError((error: any) => {
        console.log(error);
        this.mensajerror = true
        this.mensajebien = false;
        this.mensajemal = true;
        let texto = this.translateService.instant('WARNINGS.error_correo_mal');
        this.textoerror = texto + ": " + mail.emisor.bold();
        this.loading = false;
        return throwError(error);
      });

    }else{
      this.mensajerror = true
      this.mensajebien = false;
      this.mensajemal = true;
      let texto = this.translateService.instant('WARNINGS.error_correo_format');
      this.textoerror = texto + ": " + mail.emisor.bold();
      this.loading = false;
    }

    
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorWebservice(error: string) {
    this.loading = false;
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  public isValidMailFormat(email: string): boolean{
    var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (email != "" && (email.length <= 5 || !EMAIL_REGEXP.test(email))) {
      return false ;
    }else{
      return true;
    }
  }

  envioFichero() : void {
    const fichero = new FormData();
    fichero.append('files', this.fileTemp.fileRaw, this.fileTemp.fileName);
    this.dialogsSendMailsService.pushFileToStorage(fichero).subscribe(result => {
      console.log(result);
    }, error => {
      console.log("Error: " + error);
    });
  }

  public capturarFile(file: any) : any{
    const archivo = file.target.files[0];
    console.log(archivo);
    this.fileTemp = {
      fileRaw:archivo,
      fileName:archivo.name
    }
  }

}
